import React from 'react';
import { toInteger } from 'lodash';
import { connect } from 'react-redux';

import DirectoryPage from './DirectoryPage';
import { withTemplate } from '../../template/withTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';
import { CategoryDirectoryTemplate } from '../../template/CategoryDirectoryTemplate';
import { filterPartnerOnCategory } from '../../../services/filter/actions';
import { PAGE_DIRECTORY } from '../../../services/filter/constants';
import { HeadComponent } from '../../HeadComponent';

export class CategoryDirectoryPage extends React.Component {
    componentDidMount() {
        const { match } = this.props;
        const categoryId = Number(match.params.categoryId);
        if (categoryId) {
            this.props.filterPartnerOnCategory(PAGE_DIRECTORY, categoryId);
        }
    }

    render() {
        const { match, isCodePromo = false, category, Breadcrumb } = this.props;
        return (
            <div>
                <HeadComponent title={category.label} description={category.label} />
                <LocalizedBreadcrumbItem to={match.url}>{category.label}</LocalizedBreadcrumbItem>
                <DirectoryPage
                    categoryId={category && category.id ? toInteger(category.id) : -1}
                    isCodePromo={isCodePromo}
                    Breadcrumb={Breadcrumb}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        category: state.category.categories[ownProps.match.params.categoryId] || {}
    };
};

const mapDispatchToProps = {
    filterPartnerOnCategory
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(CategoryDirectoryPage),
    CategoryDirectoryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/directory/CategoryDirectoryPage.js